import { memo } from "react";
import { TransferRuleDirection } from "@common/types/transactionRule";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";
import { RuleDetailsConditionsCell } from "./RuleDetailsConditionsCell";

export const RuleDetailsFromCell = memo(
    ({ row }: { row: { original: RuleDetailsRowData } }) => (
        <RuleDetailsConditionsCell
            row={row}
            transferDirection={TransferRuleDirection.FROM}
            markerClassName="from"
        />
    ),
);

RuleDetailsFromCell.displayName = "RuleDetailsFromCell";
